export default __webpack_public_path__ + "static/switch-to-relative-drop-off-dark-mode-50a16e279c0431da0936c6b8934562a1.png";